import { apiRequest } from "../../api/apiClient";

export interface SendReportEmailPayload {
  to: string;
  subject: string;
  message?: string;
  cc?: string;
  bcc?: string;
  attachmentBase64: string;
  attachmentFileName: string;
  attachmentContentType?: string;
}

export const emailService = {
  /**
   * Email a generated report (PDF) to one or more recipients via POST /Email/send-report.
   * Throws an Error with the server message on failure.
   */
  sendReport: async (payload: SendReportEmailPayload): Promise<void> => {
    const response = await apiRequest("/Email/send-report", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        To: payload.to,
        Subject: payload.subject,
        Message: payload.message ?? "",
        Cc: payload.cc ?? "",
        Bcc: payload.bcc ?? "",
        AttachmentBase64: payload.attachmentBase64,
        AttachmentFileName: payload.attachmentFileName,
        AttachmentContentType: payload.attachmentContentType ?? "application/pdf",
      }),
    });

    if (!response.ok) {
      let message = "Failed to email the report.";
      try {
        const data = await response.json();
        if (data?.message) message = data.message;
      } catch {
        /* ignore parse errors */
      }
      throw new Error(message);
    }
  },
};
